import { useQuery } from '@tanstack/react-query';
import { getCustomerByPhone, getCustomerDetails } from '../../services/customer';

export const useCustomerLookup = (restaurantId, phone) => {
  return useQuery({
    queryKey: ['customerLookup', restaurantId, phone],
    queryFn: async () => {
      const res = await getCustomerByPhone(restaurantId, phone);
      return res?.data?.customer || null;
    },
    enabled: !!restaurantId && !!phone,
  });
};

export const useCustomerDetails = (customerId, options = {}) => {
  const { enabled = true, ...requestOptions } = options;
  return useQuery({
    queryKey: ['customerDetails', customerId, requestOptions?.restaurantId, requestOptions?.userId],
    queryFn: () => getCustomerDetails(customerId, requestOptions),
    enabled: !!customerId && enabled,
    select: (res) => res?.data,
  });
};
